// Types of functions:
//
// Cart related:
// - initialize, to empty it
// - cart CRUD, some of which requires AppConfig (potentially)
// - account transaction find/process function
//
// Base data
// - AppConfig - mostly product catalog, policies
// - Account: need the transactions and other info
//
//
//
// State here relates to app state
// i.e. shouldnt be checking out if account isnt loaded
//
// Initialization sequence
// Transaction.initialize()	-- loads appConfig and workingAccount.  Initializes Cart.
//   -- should only do this at start of the shopping process
//   -- maybe in a shop parent controller?
//	 -- async - returns a promise
// Transaction.ready() -- returns true/false (synchronously) if ready or not.
//
// Transaction.Cart...


'use strict';

angular.module('cgmemApp')
	.factory('Transaction', function ($rootScope, $q, $http, $log, AppConfig, WorkingAccount) {

		/*
		  accountId: { type: Schema.Types.ObjectId, ref: 'Account', required: true },
			memberId: { type: Schema.Types.ObjectId, ref: 'Member', required: false },
			season: {type: String, required: true},
			productCode: {type: String, required: true},
			created: {type: Date, required: true},
			completed: {type: Date, required: false},
			amount: {type: Number, required: true},
		*/

		var api = {};

		var cart = [];

		var appConfig = null;
		var workingAggregate = null;

		$rootScope.$on('$sessionEnd', function () {		// user logout
			appConfig = null;							
			workingAggregate = null;
			cart = [];
		});

		api.initialize = function () {					// Initialize the service.  Returns a promise that resolves to nothing.
			cart = [];

			return AppConfig.get()
				.then(function (ac) {
					appConfig = ac;
					return WorkingAccount.get()
				})
				.then(function (a) {
					workingAggregate = a;
					return;
				})
				.catch(function (err) {
					$log.error('Transaction.initialize failed', err);
					return $q.reject(err);
				});
		}

		api.ready = function () {
			return workingAggregate;
		}

		api.getCart = function () {
			return cart;
		}

		api.emptyCart = function () {
			cart = [];
		}

		api.transaction = function (product, member, type, amount, extra, note, qty) {
			// Figure out the price
			var self = this;

			self.amount = amount;
			self.memberId = (member ? member._id : null);
			self.season = appConfig.season;
			self.productCode = product && product.productCode;
			self.created = new Date();
			self.groupId = product && product.groupId;
			self.accountId = workingAggregate.account._id;
			self.product = product;
			self.member = member;
			self.type = type || 'purchase';	// if unspecified
			self.extra = extra;
			self.note = note;
			self.qty = qty || 1;
			if(self.type == 'purchase' || self.type == 'reversal')
				self.price = self.amount/self.qty;
		}

		api.addProductToCart = function (product, member, extra) {
			// Figure out the price
			var t = new api.transaction(product, member, 'purchase', api.currentPrice(product), extra);
			cart.push(t);
			return t;
		}

		api.addTransactionToCart = function (t) {
			cart.push(t);
			return t;
		}

		api.removeFromCart = function (product, member) {
			_.remove(cart, function (o) {
				return (o.productCode == product.productCode && (!member || o.memberId == member._id) && !o.completed);
			});
		}

		api.inCart = function (product, member) {
			return _.find(cart, { productCode: product.productCode, memberId: (member ? member._id : null) });
		};

		api.groupInCart = function (group) {
			return _.find(cart, { groupId: group.groupId });
		};

		api.removeGroup = function (group) {	//remove all products in the specified group
			_.remove(cart, function (o) {
				return (o.groupId == group.groupId);
			});
		}
		api.getTotal = function () {
			return _.sumBy(cart, 'amount');			// FIX: need to deal with credits / balance forward on account
		}

		api.save = function (p) {
			// persist to server
			if(!cart.length && !p)
				return $q.resolve();
			return $http.post('/api/transactions', p ? _.concat(cart,p) : cart)	// add payment
				.then(function (res) {
					cart = [];		// empty it to prevent resubmission
					WorkingAccount.get(null, true);
					return res.data;
				}, function (res) {
					return $q.reject('Error: ' + (res.data || res.statusText));
				});			
		}

		// FIX - this feels out of place			
		api.getAll = function() {
			return $http.get('/api/transactions');
		}
		

		api.reverse = function (t) {
			// persist to server
			return $http.delete('/api/transactions/' + t._id)
				.then(function (res) {
					WorkingAccount.get(null, true);
					return res.data;
				});
		}

		//-------------------------------		
		var postPurchaseType = function (p) {
			var r = workingAggregate.account.accountType;
			for (var i = 0; i < cart.length; i++) {
				var t = cart[i];
				if (cart[i].product && cart[i].product.transform && cart[i].product.transform.postType) {
					r = cart[i].product.transform.postType;
				}
			}
			return r;
		}

		var postPurchaseSMS = function (p) {
			var r = (workingAggregate.account.sMS && workingAggregate.account.sMS[appConfig.season]) || '';
			for (var i = 0; i < cart.length; i++) {
				var t = cart[i];
				if (cart[i].product && cart[i].product.transform && cart[i].product.transform.postSMS) {
					r = cart[i].product.transform.postSMS;
				}
			}
			return r;
		}

		api.availableProducts = function (members, group) {
			// determine # of people in key bands
			var people = _.filter(members, { deleted: false, nonMember: false }).length;
			var adults = _.filter(members, { deleted: false, adult: true, nonMember: false }).length;
			var seniors = _.filter(members, { deleted: false, senior: true, nonMember: false }).length;
			var o = [];

			_.forEach(group.personal ? _.filter(members, { deleted: false }) : [null], function (m) {		//Should add nonMember: false
				var p = _.filter(appConfig.products, function (p) {
					//console.log(group.groupId, p.groupId, p.productName, p.requiredAccountType, postPurchaseType());
					return p.groupId == group.groupId
						&& group.userSelectable
						&& (typeof api.currentPrice(p) !== "undefined")
						&& (!p.requiredAccountType || (p.requiredAccountType.indexOf(postPurchaseType()) >= 0))
						&& (!p.requiredSMS || (p.requiredSMS.indexOf(postPurchaseSMS()) >= 0))
						&& (!p.maxAge || !m || (m.age && p.maxAge >= m.age))
						&& (!p.minAge || !m || (m.age && p.minAge <= m.age))
						&& (!p.requiredAgeBand || (p.requiredAgeBand.indexOf(m.ageBandD) >= 0))
						&& (!p.maxPeople || people <= p.maxPeople)
						&& (!p.minAdults || adults >= p.minAdults)
						&& (!p.minSeniors || seniors >= p.minSeniors);
				});
				if (p.length)
					o = o.concat(m ? { member: m, productList: p } : p);
			});
			return o;
		}

		api.availableDiscounts = function (products) {		// products is [{member: m, products: [...]}]
			var discounts = [];
			var productCodeList = _(products).map('productList').flatten().map('productCode').uniq().value();
			return _.filter(appConfig.products, function (p) {
				return p.discount && api.currentPrice(p) && _.some(p.requiredProducts, function (req) {
								return (_.intersection(req, productCodeList).length == req.length);
							});
			});
		}


		api.addExtras = function () {
			var xtraGroups = _.filter(appConfig.productGroups, { autoAdd: true });
			var existingTransactions = _.filter(workingAggregate.transactions, function (t) {
				return t.type == 'purchase' && !t.reversed && t.season == appConfig.season;
			}).concat(cart);
			//$log.log("Existing Transactions:", existingTransactions);
			var etByMemberId = _.groupBy(_.filter(existingTransactions, 'member._id'), function (t) {
				return (t.member ? t.member._id : null);
			});
			_.forEach(xtraGroups, function (group) {
				_.forEach(_.filter(appConfig.products, function(p) {
									return p.groupId == group.groupId && (typeof api.currentPrice(p) !== "undefined")
								}), function (product) {	// FIX: need to ensure pricing for xtra is valid
					//$log.debug("Thinking of adding ",product.productCode);
					if (group.personal) {
						// need to look member by member
						_.forEach(etByMemberId, function (memberTransactionList, key) {
							var memberProducts = _.map(memberTransactionList, 'product.productCode');
							//$log.debug("Member ",key, "has products",memberProducts);
							var preqsMet = _.some(product.requiredProducts, function (req) {
								return (_.intersection(req, memberProducts).length == req.length);
							});
							//$log.debug("Met: ",(preqsMet?true:false));
							var alreadyIn = (memberProducts.indexOf(product.productCode) >= 0);
							//$log.debug("Already in: ", (memberProducts.indexOf(product.productCode) >= 0));
							if (!alreadyIn && preqsMet)
								api.addProductToCart(product, memberTransactionList[0].member);		//Not ideal.  May not be up to date version of member.
						});
					}
				});
			});
		}


		api.applicablePolicies = function () {
			var policyIds = _(cart).map('product').map('policies').flatten(true).compact().uniq().value();
			return _.filter(appConfig.policies, function (p) {
				return (policyIds.indexOf(p.policyId) >= 0);
			});
		}

		api.findTrans = function (product, member) {
			return _.find(workingAggregate.transactions, function (t) {
				return t.type == 'purchase'
					&& t.season == appConfig.season
					&& t.productCode == product.productCode
					&& (!member || t.member._id == member._id)
					&& (t.completed)
					&& !t.reversed;
			});
		};

		api.currentPrice = function(p) {
			var now = new moment();
			now.subtract(AppConfig.getOffset(), 'ms');
			var validPriceRec = _.find(p.price, function(pr) {
				var s = moment.tz(pr.startDate, 'MM/DD/YYYY',  "America/New_York");
				var e = moment.tz(pr.endDate, 'MM/DD/YYYY',  "America/New_York").add(1,'d');
				return(now.isSameOrAfter(s) && now.isBefore(e));
			});
			//$log.log(p);
			//$log.log(validPriceRec)
			return validPriceRec && validPriceRec.price;
		}

		return api;
	});
